/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 16:20:06 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2021-01-19 09:46:49
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import JsCookie from 'js-cookie'
import moment from 'moment';
import { Message } from 'element-ui'

// import 'lib-flexible'

import App from './App.vue';// 入口页
import routes from './router';// 路由配置
import env from './config/env';// 环境配置
import clickoutside from './directives/clickoutside';//自定义指令（点击空白处）
import vueNiceScroll from './directives/niceScroll';
import Util from '@/utils/Util';
import filter from '@/filter';

//公共样式
import './assets/etheme/index.css';//elementUI主题
import 'swiper/dist/css/swiper.css'
import './assets/iconfont/iconfont.css';
import './assets/styles/common.scss';


Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(clickoutside);
Vue.use(vueNiceScroll);

// 公共组件引入
import TimeSelect from "@/components/TimeSelect"; //时间选择
import MultipleSelect from "@/components/MultipleSelect"; //多选
import Search from "@/components/Search"; //搜索框
import CitySearch from "@/components/CitySearch"; //城市选择
import MultipleSelectDiy from "@/components/MultipleSelectDiy"; //城市选择多选
import CompanySearch from "@/components/CompanySearch"; //房企选择
import CompanySearchNew from "@/components/CompanySearchNew"; //房企选择
import SubSelect from "@/components/SubSelect"; //二级多选
import TableList from "@/components/TableList"; //表格列表
import Pagination from "@/components/Pagination"; //分页器
import SwiperList from "@/components/SwiperList"; //swiper top 列表
import ScrollBox from "@/components/ScrollBox"; //滚动盒子
Vue.component('TimeSelect', TimeSelect);
Vue.component('MultipleSelect', MultipleSelect);
Vue.component('Search', Search);
Vue.component('CitySearch', CitySearch);
Vue.component('MultipleSelectDiy', MultipleSelectDiy);
Vue.component('CompanySearch', CompanySearch);
Vue.component('CompanySearchNew', CompanySearchNew);
Vue.component('SubSelect', SubSelect);
Vue.component('TableList', TableList);
Vue.component('Pagination', Pagination);
Vue.component('SwiperList', SwiperList);
Vue.component('ScrollBox', ScrollBox);

Vue.config.productionTip = false;// 阻止 vue 在启动时生成生产提示



//全局对象工具
Vue.prototype.$UtilTool = Util;

const router = new VueRouter({
    routes,
    canReuse: false,
    linkActiveClass: 'selected',
    mode: env.routerMode,
    strict: process.env.NODE_ENV !== 'production'
});

// 路由拦截
router.beforeEach((to, from, next) => {

    // 百度统计
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }

    // 设置token失效时间(此处为30分钟)
    let startTime = localStorage.getItem('sZfyxTime')
    let endTime = moment()
    let diff = endTime.diff(startTime,'minute')
    let uid = localStorage.getItem('sZfyxUid')
    console.log(diff,uid)

    // 针对大屏用户，不做30分钟登录失效处理
    if(uid != 8706 && diff >= 30){
        localStorage.removeItem('sZfyxToken');
    }else{
        localStorage.setItem('sZfyxTime',moment())
    }

    let token = localStorage.getItem('sZfyxToken')

    // console.log('路由拦截',to)
    console.log('cookie1===>',JsCookie.get('WU0001','.youcaiyun.com'))
    console.log('cookie2===>',JsCookie.get('AU0001','.youcaiyun.com'))

    let sourceUrl = window.location.href
    console.log('sourceUrl',sourceUrl)
    if(to.meta.requireLogin&&!token){

        window.location.href='http://youcaiyun.com/Pages/Account/Login.aspx?tourl='+sourceUrl
    }

    let  userType = Number(localStorage.getItem('sZfyxType')) ;

    let  sUserRole = []
    if(localStorage.getItem('sZfyxRole')){
        sUserRole = localStorage.getItem('sZfyxRole').split(',').map(Number);
    }
    console.log(sUserRole,111)
    console.log(userType,222)

    console.log(sUserRole.length,999999999)
    if( to.path !== '/login'
        && ( (sUserRole.length!==0 && !sUserRole.includes(to.meta.role)) || ( !to.meta.type.includes(userType))) ){

        console.log(to.path,'--------')
        Message({
            message: '您不是VIP会员，无查看权限。购买咨询：010-68002661',
            type: 'warning'
        });
        setTimeout( () => {
            // window.history.go(-1)
        },1000)
        return false;
    }
    next()
})

new Vue({
    router,
    filter,
    render: h => h(App)
}).$mount('#app')